import { render } from "./App.vue?vue&type=template&id=1c4f9e67"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import exportComponent from "D:\\yuqiang\\笔记\\git-document\\document\\workspace\\modingtech\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__